import { combineReducers } from '@reduxjs/toolkit'
import appProvider from './appProviderSlice'

const reducer = combineReducers({
    appProvider,
})

export default reducer
